export const TRANSLATIONS = {
  feature: 'Wix_Ads',
  desktop: {
    title: {
      key: 'Wix_Ads_Co_Branding_Top_Banner',
      defaultText: 'This website was created by',
    },
  },
  mobile: {
    title: {
      key: 'Wix_Ads_Mobile_Co_Branding_Top_Banner',
      defaultText: 'This website was created by {Logo}',
    },
  },
  dayful: {
    title: {
      key: 'Wix_Ads_Dayful_Co_Branding_Top_Banner',
      defaultText: 'Powered by {Logo}',
    },
  },
} as const;

export const TEST_IDS = {
  logo: 'logo',
  title: 'title',
  brandName: 'brandName',
  logoWrapper: 'logoWrapper',
} as const;
